import { useEffect, useState } from "react";
import Button from "../components/atoms/button";
import Link from "../components/atoms/link";
import Paragraph from "../components/atoms/paragraph";
import Title from "../components/atoms/title";
import "../styles/input.scss";
import { useNavigate } from "react-router-dom";
import Loader from "../components/atoms/loader";
import { ValidateCodeUseCase } from "../../application/use-cases/validateCode.usecase";
import OtpUtilService from "../services/otpUtil.service";
import {listText, objListText} from "../utils/dictionaries/dictionary-validate-code";
import Top from "../components/templates/top";
import TitleAndImage from "../components/molecules/title-and-image";
import penSharpRegular from "../assets/icons/pen-sharp-regular.svg";
import BottomSheetFieldModification from "../components/templates/bottom-sheet-field-modification";
import contactInfoUtilService from "../services/contactInfoUtil.service";
import { ContactInfoUseCase } from "../../application/use-cases/contactInfo.usecase";
import AcceptAuthorizeUtilService from "../services/acceptAuthorizeUtil.service";
import { classAcceptAuthorizeUseCase } from "../../application/use-cases/acceptAuthorize.usecase";
import { dateISO } from "../utils/helpers";
import { store } from "../redux/store";
import { useDispatch } from "react-redux";
import { changeEmail, changePhone, changeVerifyEmail } from "../redux/slices/dataReducer";
import { addOTP } from "../redux/slices/otpReducer";
import { changeEditableValue } from "../redux/slices/navigateReducer";
import InputDiamondComponent from "../components/organisms/input-diamond";
import "../styles/otpInput.scss";
import MessagesReactModal from "../components/templates/messages-react-modal";
import hexagonExclamationThin from "../assets/icons/hexagon-exclamation-thin.svg";
import ic_xclose from "../assets/icons/ic_xclose.svg";
import { useFollowLater } from "../hooks/useFollowLater";

const ValidateCode = () => {
  const { onClickContinue } = useFollowLater();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = store.getState();
  const [modalShow, setModalShow] = useState(false);

  const otpService = new OtpUtilService();
  const usecaseOtp = new ValidateCodeUseCase(otpService);

  const contactInfoService = new contactInfoUtilService();
  const usecaseContactInfo = new ContactInfoUseCase(contactInfoService);

  const caseServiceAutorice = new AcceptAuthorizeUtilService();
  const useCaseAutorize = new classAcceptAuthorizeUseCase(caseServiceAutorice);

  const [seconds, setSeconds] = useState(0);
  const [showValidateCode, setShowValidateCode] = useState(false);
  const [title, setTitle] = useState<string | undefined>("");
  const [editableValueText, setEditableValueText] = useState<string | undefined>("");
  const [conditionShowInputs, setConditionShowInputs] = useState({
    phoneValidate: false,
    mailValidate: false,
  });
  const [displayErrorByCode, setDisplayErrorByCode] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [isOpenBottonSheet, setOpenBottonSheet] = useState(false);
  const [showValue, setShowValue] = useState(state.client.navigatePersist.editableValue);
  const [otpLength, setOtpLength] = useState(0);
  const [otp, setOtp] = useState("");

  const onChange = (value: string) => {
    const otpL = value.trim().length;
    setOtpLength(otpL);
    setOtp(value);
    setDisabledButton(false);
  };

  const onSubmit = async (d: any) => {
    setShowValidateCode(true);
    setDisplayErrorByCode(false);

    const responseValidateOtp = await usecaseOtp.validateOtp(
      {
        registerCode: otp,
        phone: state.client.dataPersist.phone,
      },
      state.client.clientPersist.uuid,
    );

    if (responseValidateOtp.error !== null) {
      setDisplayErrorByCode(true);
      setDisabledButton(true);
    } else {
      dispatch(
        addOTP({
          registerCode: otp,
        }),
      );
      if (state.client.navigatePersist.comeFrom === "IneConsent") {
        const saveAcceptance = await useCaseAutorize.ineConsenAcceptances({
          processId: state.client.clientPersist.uuid,
          phone: state.client.dataPersist.phone,
          latitude: "",
          longitude: "",
          registerCode: otp,
          acceptanceDate: dateISO(),
        });

        if (saveAcceptance.error != null) {
          setModalShow(true);
        } else {
          navigate("/CaptureINE");
          onClickContinue({
            data: { ...state.client.dataPersist },
            processId: state.client.clientPersist.uuid,
            resource: "ValidateCode",
            step: "CONTINUE",
          });
        }
      } else if (state.client.navigatePersist.comeFrom === "AccountOpening") {
        const responseSendContactInfo = await usecaseContactInfo.sendContactInf({
          processId: state.client.clientPersist.uuid,
          isClient: state.client.dataPersist.isClient,
          phone: state.client.dataPersist.phone,
          email: state.client.dataPersist.email,
          emailVerify: true,
          acceptanceDate: dateISO(),
        });

        if (responseSendContactInfo.error == null) {
          dispatch(changeVerifyEmail(true));
          navigate(state.client.navigatePersist.nextContinue);
        }
      } else if (state.client.navigatePersist.comeFrom == "ContractCondition") {
        const saveSignatureData = await useCaseAutorize.saveSignatureData({
          latitude: "",
          longitude: "",
          registerCode: otp,
          acceptanceDate: dateISO(),
          digitalSignatureB64: ""
        }, state.client.clientPersist.uuid);
        if (saveSignatureData.error != null) {
          setModalShow(true);
          setShowValidateCode(false);
          return;
        }
        navigate(state.client.navigatePersist.nextContinue);
      } else if (state.client.navigatePersist.comeFrom == "IdentityValidation") {
        navigate(state.client.navigatePersist.nextContinue);
      } else {
        setShowValidateCode(true);
        navigate("/IdentificationQuestionnaire");
        onClickContinue({
          data: {},
          processId: state.client.clientPersist.uuid,
          resource: "ValidateCode",
          step: "CONTINUE",
        });
      }
    }
    setShowValidateCode(false);
  };

  useEffect(() => {
    const dataText = listText.find((e: { id: string; }) => e.id === state.client.navigatePersist.typeValue);
    setTitle(dataText?.texts.text_1.mainText);
    setEditableValueText(dataText?.texts.text_2.mainText);
    if (state.client.navigatePersist.typeValue === "phone") {
      setConditionShowInputs({ phoneValidate: true, mailValidate: false });
    } else if (state.client.navigatePersist.typeValue === "mail") {
      setConditionShowInputs({ phoneValidate: false, mailValidate: true });
    }
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  useEffect(() => {
    setSeconds(90);
  }, []);

  const resendOTP = async (value: any) => {
    setSeconds(90);
    await usecaseOtp.sendOtp(
      {
        phone:
          state.client.navigatePersist.typeValue === "phone"
            ? value
            : state.client.dataPersist.phone,
        email:
          state.client.navigatePersist.typeValue === "mail"
            ? value
            : state.client.dataPersist.email,
        channel: state.client.navigatePersist.typeValue === "mail" ? "EMAIL" : "SMS",
        date: dateISO(),
      },
      state.client.clientPersist.uuid,
    );
  };

  const changeValueFunction = (value: any) => {
    setShowValue(value);
    dispatch(changeEditableValue({ editableValue: value }));

    if (state.client.navigatePersist.typeValue === "phone") {
      dispatch(changePhone(value));
    } else {
      dispatch(changeEmail(value));
    }

    resendOTP(value);
    setOpenBottonSheet(false);
  };

  const goBack = () => {
    state.client.navigatePersist.isReturn
      ? navigate(`/${state.client.navigatePersist.comeFrom}`)
      : null;
  };

  const followLaterAction = () => {
    navigate("/FollowLater", {
      state: {
        processId: state.client.clientPersist.uuid,
        resource: "ValidateCode",
        step: "CONTINUE_AFTER",
        data: {}, // Agregar data del formulario
      },
    });
  };

  return (
    <>
      {showValidateCode ? (
        <Loader />
      ) : (
        <>
          <div className="content-container">
            <Top
              titleHeader={"Apertura de cuenta"}
              subTitle={"Código OTP"}
              displayProgressBar={""}
              displayLeftImageTitle={!state.client.navigatePersist.isReturn ? "d-none" : ""}
              classTitleImage={state.client.navigatePersist.isReturn ? "ms-2" : ""}
              classHeader={"mt-2"}
              styleHeader={{}}
              classProgressBar={"mt-3"}
              styleProgressBar={{}}
              classTitleAndImage={""}
              styleTitleAndImage={{}}
              valueProgressBar={state.client.navigatePersist.progressBarPercentage}
              comeFrom={"/ValidateCode"}
              onClickGoBackIcon={() => goBack()}
            />
            <div className="p-3">
              <Title
                text={title}
                className={"fs-6 fw-bold lh-base dark-blue-title"}
                styleTitle={undefined}
              />
              <div
                style={{ textAlign: "center", backgroundColor: "#F7F7F7" }}
                className="my-4 pt-3 rounded-2 w-100"
              >
                <strong>{showValue}</strong>
                <TitleAndImage
                  srcImage={penSharpRegular}
                  titleText={editableValueText}
                  displayLeftImageTitle={""}
                  classTitle={"m-2"}
                  styleTitle={{
                    color: "#5A97D5",
                    lineHeight: "16px",
                    textDecoration: "none",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                  onClickTitleImgeDiv={() => setOpenBottonSheet(true)}
                  divClass={"mt-3 pb-2"}
                />
              </div>
              <Paragraph
                text={"Si no recibes el código, espera 90 segundos y vuelve a solicitarlo."}
                className={"fs-6 mb-4_3"}
                styleParagraph={undefined}
              />
              <div className="d-flex justify-content-between m-3">
                <InputDiamondComponent
                  autoFocus
                  isNumberInput
                  length={4}
                  classError={displayErrorByCode ? "border-dangerous-red" : ""}
                  className="otpContainer"
                  inputClassName="otpInput"
                  onChangeOTP={(otp) => onChange(otp)}
                />
              </div>

              <div className="text-center py-4">
                <p style={{ color: "#C94444" }} className={displayErrorByCode ? "" : "d-none"}>
                  Código de verificación inválido.
                  <br />
                  Revisa tu código y vuelve a ingresarlo
                </p>
                {seconds > 0 ? (
                  <p className="fs-6">
                    {"Reenviar código en"}
                    <span className="orange-color"> {seconds} </span>seg.
                  </p>
                ) : (
                  <></>
                )}
                <Link
                  text={"Volver a solicitar"}
                  url={null}
                  styleLink={{
                    color: seconds > 0 ? "#CBCFD6" : "#004A94",
                    fontWeight: "600",
                    lineHeight: "20px",
                    pointerEvents: seconds > 0 ? "none" : "auto",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    resendOTP(
                      state.client.navigatePersist.typeValue == "mail"
                        ? state.client.dataPersist.email
                        : state.client.dataPersist.phone,
                    )
                  }
                  className={""}
                />
              </div>
            </div>
          </div>
          <div className="footer--pin">
            <Button
              text={state.client.navigatePersist.textButton}
              divClassName={""}
              buttonClassName={
                "btn-bg-primary text-white w-100 place-content-center align-self-center"
              }
              spinner={false}
              onClick={(d: any) => onSubmit(d)}
              disabled={otpLength !== 4 || disabledButton}
              dataBsDismiss={undefined}
            />
            <div className="text-center mt-3">
              <Link
                text={"Seguir más tarde"}
                url={null}
                styleLink={{
                  color: "#5A6172",
                  lineHeight: "16px",
                  textDecoration: "none",
                  cursor: "pointer",
                }}
                onClick={followLaterAction}
                className={""}
              />
            </div>
          </div>
          <BottomSheetFieldModification
            title={editableValueText}
            textButton={editableValueText}
            conditionShowInputs={conditionShowInputs}
            isOpen={isOpenBottonSheet}
            onClickClose={() => setOpenBottonSheet(false)}
            changeValueFunction={(value: any) => changeValueFunction(value)}
          />
        </>
      )}
      <MessagesReactModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textTitle={objListText.text_1.mainText}
        classTitle={"fw-bold"}
        styleTitle={{ color: "#00254A", fontSize: "20px", fontWeight: "700" }}
        listButtonsModal={[
          {
            text: objListText.text_2.mainText,
            style: {},
            divClass: "",
            buttonClass: "button-enabled w-100 place-content-center align-self-center mt-3",
            spinner: false,
            onClick: () => { setModalShow(false)},
            disabled: false,
          },
        ]}
        imageModal={hexagonExclamationThin}
        onClickClose={() => setModalShow(false)}
        imageOnlyClose={ic_xclose}
        classContent={"ml-3 mr-3 mb-3 text-center"}
        classImageModal={"text-center my-4"}
        listParagraphs={[
          {
            textParagraph: objListText.text_3.mainText,
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
          {
            textParagraph: objListText.text_4.mainText,
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
        ]}
      />
    </>
  );
};

export default ValidateCode;
